import React, { useCallback, useEffect, useRef } from "react";

import {
  IDelegatingErrorBoundaryConfig,
  IReportingErrorBoundaryConfig,
  IReportingErrorBoundaryProps
} from "../Types/IDelegatingErrorBoundary";

/**
 * Wraps the delegated child boundary with appropriate reporting side-effect behaviors.
 */
const ReportingDelegatingErrorBoundary: React.FC<
  IDelegatingErrorBoundaryConfig & IReportingErrorBoundaryProps & IReportingErrorBoundaryConfig
> = ({ bearerToken, flowId, leadId, DelegatedErrorBoundary, Fallback, useReportError, children }) => {
  const hookArgsRef = useRef({ flowId, leadId, bearerToken });
  useEffect(() => {
    hookArgsRef.current = { flowId, leadId, bearerToken };
  }, [flowId, leadId, bearerToken]);

  const { execute } = useReportError();
  const onError = useCallback(() => {
    if (hookArgsRef.current.flowId && hookArgsRef.current.leadId && hookArgsRef.current.bearerToken)
      execute({
        flowId: hookArgsRef.current.flowId,
        leadId: hookArgsRef.current.leadId,
        bearerToken: hookArgsRef.current.bearerToken
      });
  }, []);

  return (
    <DelegatedErrorBoundary onError={onError} Fallback={Fallback}>
      {children}
    </DelegatedErrorBoundary>
  );
};

export default ReportingDelegatingErrorBoundary;
